// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-wrapper[data-v-8989a09a]{width:350px}.v-btn--active.no-active[data-v-8989a09a]:before{display:none}.notification-icon[data-v-8989a09a]{padding-top:6px!important}[data-v-8989a09a] .v-snack__action{margin:0!important}[data-v-8989a09a] .v-snack__wrapper{box-shadow:0 0 10px 0 rgba(0,0,0,.2)!important}", ""]);
// Exports
module.exports = exports;
